import builder from './reducerBuilder'
import {
  ACTION_AUTHORIZATION_INVITATIONS_ERROR,
  ACTION_AUTHORIZATION_INVITATIONS_LOADED,
  ACTION_AUTHORIZATION_INVITATIONS_LOADING,
} from '../constants'

export default builder(
  ACTION_AUTHORIZATION_INVITATIONS_LOADING,
  ACTION_AUTHORIZATION_INVITATIONS_LOADED,
  ACTION_AUTHORIZATION_INVITATIONS_ERROR)



// WEBPACK FOOTER //
// ./src/store/invitationsReducer.js